import type { ContextoErro } from './index'

export type ClassificacaoErro = 'incidente' | 'qualidade' | 'descarte'

/** Categoria vem da borda que conhece o resultado; status HTTP sozinho não decide. */
export const classificarErro = (contexto: ContextoErro): ClassificacaoErro => {
  switch (contexto.categoria) {
    case 'cancelamento':
    case 'validacao':
      return 'descarte'
    case 'qualidade':
      return 'qualidade'
    case undefined:
    case 'inesperado':
    default:
      return 'incidente'
  }
}
